export default __webpack_public_path__ + "static/image--blog-1-ae52c3d3c28fb0bf88f39720f5537a49.jpg";